module.exports = __webpack_public_path__ + "static/img/exam-8-bg.1df519d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/exam-8-bg.png
// module id = 7F8f
// module chunks = 1